import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";

const Section = ({
  children,
  className,
  containerClass,
  maxWidth,
  sx,
  pt,
  pb,
  py,
  disableContainer = false,
  ...props
}) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Box
      className={className}
      sx={{
        pt: pt || (md ? 14 : 8),
        pb: pb || (md ? 14 : 8),
        py: py,
        ...sx,
      }}
      {...props}
    >
      {!disableContainer ? (
        <Container
          className={containerClass}
          maxWidth={maxWidth || xl ? "xl" : "lg"}
        >
          {children}
        </Container>
      ) : (
        children
      )}
    </Box>
  );
};

export default Section;
